import './index.css';
import { useEffect, useState } from 'react';
import useGame from '../../../utilities/hooks/game';
import Constants from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import { useLink } from 'react-router-stack';
import FixturesMatchListMWeb from './index_mWeb';
import FixturesMatchListWeb from './index_web';

const FixturesMatchList = ({ list }: any) => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const { gameType, fantasyMatchClick } = useGame();
  const [upcomingMatchList, setUpcomingMatchList] = useState([] as any);
  const { myAnswersList: fantasyYesOrNoMyAnswersList } = useSelector(
    (state: any) => state.fantasy_yes_no
  );

  useEffect(() => {
    setUpcomingMatchList([...list]);
  }, []);

  const onPressMatchCard = (matchItem: any) => {
    const data = {
      ...matchItem,
      completed: false,
      joined: false,
      joinedMatch: false,
      contestId: '',
      entryFee: '',
      isTeamSwitch: false,
      tabType: 'FIXTURE',
      selectedTeamPlayers: []
    };
    dispatch(fantasyMatchClick({ data }));
    if (gameType === Constants.GameType.FANTASY_YES_NO) {
      checkedMyAnswer_(data);
    } else {
      navigate.push(getRouteObjByGame(gameType)['home_tab']);
    }
  };

  const checkedMyAnswer_ = async (matchItem: { _id: any }) => {
    fantasyMatchClick({
      data: {
        ...matchItem
      }
    });

    if (fantasyYesOrNoMyAnswersList[matchItem._id as keyof typeof fantasyYesOrNoMyAnswersList]) {
      navigate.push(getRouteObjByGame(gameType)['home_tab']);
    } else {
      navigate.push('my_que_ans');
    }
  };

  const onPressAddSubstitute = () => {};

  return (
    <>
      {isSmartPhone ? (
        <FixturesMatchListMWeb
          upcomingMatchList={upcomingMatchList}
          onPressMatchCard={onPressMatchCard}
          gameType={gameType}
          onPressAddSubstitute={onPressAddSubstitute}
        />
      ) : (
        <FixturesMatchListWeb
          upcomingMatchList={upcomingMatchList}
          onPressMatchCard={onPressMatchCard}
          gameType={gameType}
          onPressAddSubstitute={onPressAddSubstitute}
        />
      )}
    </>
  );
};

export default FixturesMatchList;
